import apiClient from './apiClient';

export const dashboardApi = {
  // Übersicht
  getOverview: async () => {
    const response = await apiClient.get('/dashboard/overview');
    return response.data;
  },

  // Umsatz-Daten
  getUmsatzDaten: async (zeitraum = 'letzten-12-monate', startDatum = null, endDatum = null) => {
    const params = { zeitraum };
    if (startDatum) params.startDatum = startDatum;
    if (endDatum) params.endDatum = endDatum;

    const response = await apiClient.get('/dashboard/umsatz', { params });
    return response.data;
  },

  // Top Kunden
  getTopKunden: async () => {
    const response = await apiClient.get('/dashboard/top-kunden');
    return response.data;
  },

  // Offene Forderungen
  getOffeneForderungen: async () => {
    const response = await apiClient.get('/dashboard/offene-forderungen');
    return response.data;
  },

  // Statistiken
  getStatistiken: async () => {
    const response = await apiClient.get('/dashboard/statistiken');
    return response.data;
  }
};
